/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IStakedTokenWithConfig,
  IStakedTokenWithConfigInterface,
} from "../IStakedTokenWithConfig";

const _abi = [
  {
    inputs: [],
    name: "STAKED_TOKEN",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "claimRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "cooldown",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "redeem",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "stake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IStakedTokenWithConfig__factory {
  static readonly abi = _abi;
  static createInterface(): IStakedTokenWithConfigInterface {
    return new utils.Interface(_abi) as IStakedTokenWithConfigInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IStakedTokenWithConfig {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as IStakedTokenWithConfig;
  }
}
